import styled from 'styled-components'

import FacebookIcon from 'components/icons/FacebookFa'
import InstagramIcon from 'components/icons/InstagramFa'
import PinterestIcon from 'components/icons/PinterestFa'

const SocialLinks = styled.div`
  display: flex;

  & > *:not(:last-child) {
    margin-right: 18px;
  }

  svg {
    width: 22px;
    color: ${({ theme }) => theme.colors.white};
  }
`

const SocialMenu = () => {
  return (
    <SocialLinks>
      <a
        href="https://instagram.com/riparide"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <InstagramIcon />
      </a>
      <a
        href="https://www.facebook.com/pages/Riparide/226117010788780"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
      >
        <FacebookIcon />
      </a>
      <a
        href="https://www.pinterest.com.au/riparide/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Pinterest"
      >
        <PinterestIcon />
      </a>
    </SocialLinks>
  )
}

export default SocialMenu
